import { Share } from '@mui/icons-material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ShareIcon from '@mui/icons-material/Share';
import { List, ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import React from 'react';
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  EmailShareButton,
} from 'react-share';

import WsColors from '../../WsColors';
import { WsButton } from '../WsButton';
import { WsElementWithPopOver } from '../WsElementWithPopOver';
import FaceBookIcon from '../WsIcon/FaceBookIcon';
import LinkdinIcon from '../WsIcon/LinkdinIcon';
import TwitterIcon from '../WsIcon/TwitterIcon';
import WhatsAppIcon from '../WsIcon/WhatsAppIcon';
import WSIconEmail from '../WsIcon/WsIconEmail';

export interface ShareJobProps {
  shareUrl: string;
  shareUrlLinkedIn: string;
  title: string;
  emailSubject?: string;
  emailBody?: string;
  iconColor?: string;
  page?: string;
  isGrey?: boolean;
  showFaceBook?: boolean;
  showTwitter?: boolean;
  showWhatsApp?: boolean;
  showLinkedIn?: boolean;
  showEmail?: boolean;
  iconSize?: 'small' | 'medium' | 'large';
  indexJob?: (source?: string) => void;
  variant?: ShareJobVariant;
  amplitudeEventHandler?: (eventName: string) => void;
  clipBoard?: (data: string) => void;
}

export enum ShareJobVariant {
  ICON = 'icon',
  BUTTON = 'button',
}

export const ShareJob: React.FC<ShareJobProps> = ({
  shareUrl,
  shareUrlLinkedIn,
  iconColor,
  title,
  emailBody,
  emailSubject,
  isGrey,
  showEmail = true,
  showFaceBook = true,
  showLinkedIn = true,
  showTwitter = true,
  showWhatsApp = true,
  iconSize = 'medium',
  indexJob = () => {},
  amplitudeEventHandler = () => {},
  variant = ShareJobVariant.ICON,
  clipBoard,
}: ShareJobProps) => (
  <WsElementWithPopOver
    element={
      variant === ShareJobVariant.ICON ? (
        <ShareIcon
          style={{ color: isGrey ? WsColors.TertiaryShades500 : WsColors.GenericRichBlack }}
          fontSize={iconSize}
        />
      ) : (
        <WsButton variant="outlined" size="medium" startIcon={<Share />}>
          Share
        </WsButton>
      )
    }
  >
    <List dense={true}>
      {showFaceBook && (
        <ListItem disablePadding>
          <FacebookShareButton
            quote={title}
            url={`${shareUrl}?utm_source=facebook`}
            beforeOnClick={() => indexJob('facebook')}
            onClick={() => amplitudeEventHandler('facebook')}
          >
            <ListItemButton sx={{ width: 150 }}>
              <ListItemIcon>
                <FaceBookIcon color={iconColor} />
              </ListItemIcon>

              <ListItemText primary="facebook" />
            </ListItemButton>
          </FacebookShareButton>
        </ListItem>
      )}
      {showWhatsApp && (
        <ListItem disablePadding>
          <WhatsappShareButton
            url={`${shareUrl}?utm_source=whatsapp`}
            onClick={() => amplitudeEventHandler('whatsapp')}
            beforeOnClick={() => indexJob('whatsapp')}
          >
            <ListItemButton sx={{ width: 150 }}>
              <ListItemIcon>
                <WhatsAppIcon color={iconColor} />
              </ListItemIcon>

              <ListItemText primary="whatsapp" />
            </ListItemButton>
          </WhatsappShareButton>
        </ListItem>
      )}
      {showTwitter && (
        <ListItem disablePadding>
          <TwitterShareButton
            url={`${shareUrl}?utm_source=twitter`}
            onClick={() => amplitudeEventHandler('twitter')}
            beforeOnClick={() => indexJob('twitter')}
          >
            <ListItemButton sx={{ width: 150 }}>
              <ListItemIcon>
                <TwitterIcon color={iconColor} />
              </ListItemIcon>

              <ListItemText primary="twitter" />
            </ListItemButton>
          </TwitterShareButton>
        </ListItem>
      )}
      {showLinkedIn && (
        <ListItem disablePadding>
          <LinkedinShareButton
            url={`${shareUrlLinkedIn}?utm_source=linkedin`}
            onClick={() => amplitudeEventHandler('linkedin')}
            beforeOnClick={() => indexJob('linkedin')}
          >
            <ListItemButton sx={{ width: 150 }}>
              <ListItemIcon>
                <LinkdinIcon color={iconColor} />
              </ListItemIcon>

              <ListItemText primary="LinkedIn" />
            </ListItemButton>
          </LinkedinShareButton>
        </ListItem>
      )}
      {showEmail && (
        <ListItem disablePadding>
          <EmailShareButton
            url={`${shareUrl}?utm_source=email`}
            subject={emailSubject}
            body={emailBody}
            beforeOnClick={() => indexJob('email')}
            openShareDialogOnClick={true}
            onClick={() => amplitudeEventHandler('email')}
          >
            <ListItemButton sx={{ width: 150 }}>
              <ListItemIcon>
                <WSIconEmail color={iconColor} />
              </ListItemIcon>

              <ListItemText primary="Email" />
            </ListItemButton>
          </EmailShareButton>
        </ListItem>
      )}
      <ListItem disablePadding>
        <ListItemButton sx={{ width: 150 }} onClick={() => clipBoard && clipBoard(shareUrl)}>
          <ListItemIcon>
            <ContentCopyIcon color="primary" fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Copy Link" />
        </ListItemButton>
      </ListItem>
    </List>
  </WsElementWithPopOver>
);
